import { Button, Typography } from '@mui/material';
import React, { useEffect, useState } from "react";
import {
    Box,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Paper,
    Grid,
    FormControl,
    TextField,
    Autocomplete
} from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import Loader from '../common/Loader';
import PageTitle from '../common/PageTitle';
import { tableData, tableHeader } from '../utils';
import EmptyTable from '../common/EmptyTable';
import { getAPI } from '../network';
import { convertToTimezone } from '../../utils/helper'
export default function PanicAlarm() {
    const dispatch = useDispatch();
    const navigateTo = useNavigate();

    let companyId = localStorage.getItem('companyIdLS');
    if (companyId === null) {
        companyId = undefined;
    }
    const { siteId } = useParams();
    const [loader, setLoader] = useState(false);
    const [panic, setPanic] = useState([]);
    const [page, setPage] = useState(0);
    const [perPages, setPerPages] = useState([5, 10, 25, 50]);
    const [perPage, setPerPage] = useState(10);

    // Filters
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    const panicAlarm = async () => {
        setLoader(true);
        const data = await getAPI(`/user/home/panicList?siteId=${siteId}`);
        setPanic(data);
        setLoader(false);
    };

    useEffect(() => {
        panicAlarm();
    }, []);

    const handleMapNavigate = (latitude, longitude) => {
        const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(googleMapsUrl, '_blank');
    };

    const handleChangeRowsPerPage = (event) => {
        setPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Generate unique user list for dropdown
    const userList = [...new Map(
        panic.map(item => [item.userId?._id, {
            id: item.userId?._id,
            name: `${item.userId?.firstname} ${item.userId?.lastname}`
        }])
    ).values()];

    // Filtering logic
    const filteredPanic = panic.filter(item => {
        const itemDate = new Date(item.date);
        const isAfterStart = startDate ? new Date(startDate) <= itemDate : true;
        const isBeforeEnd = endDate ? itemDate <= new Date(endDate) : true;
        const isUserMatch = selectedUser ? item.userId?._id === selectedUser.id : true;
        return isAfterStart && isBeforeEnd && isUserMatch;
    });

    return (
        <Box>
            <Loader loader={loader} />
            <PageTitle title="Panic Alarm Triggered List" />

            <Box ml={2}>
                <FormControl fullWidth>
                    <Grid container spacing={2} sx={{ mt: 2, mb: 3 }}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Start Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="End Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                options={userList}
                                getOptionLabel={(option) => option.name}
                                value={selectedUser}
                                onChange={(event, newValue) => setSelectedUser(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Filter by User" variant="outlined" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button
                                variant="outlined"
                                sx={{ mt: 1, ml: 1 }}
                                onClick={() => {
                                    setStartDate('');
                                    setEndDate('');
                                    setSelectedUser(null);
                                }}
                            >
                                Clear Filters
                            </Button>

                        </Grid>
                    </Grid>
                </FormControl>

                <Box display="flex">
                    <TableContainer component={Paper}>
                        <Table
                            sx={{ minWidth: "auto" }}
                            aria-label="custom pagination table"
                            className="responsive-table"
                        >
                            <TableHead>
                                <TableRow className="table-header">
                                    <TableCell align="left" component="th" sx={tableHeader}>Date & Time</TableCell>
                                    <TableCell align="left" component="th" sx={tableHeader}>Site</TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>User Name</TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>User Email</TableCell>
                                    <TableCell align="center" component="th" sx={tableHeader}>Location</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredPanic?.slice(page * perPage, page * perPage + perPage).map((task, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="left" sx={tableData}>
                                            {convertToTimezone(task?.date)}
                                        </TableCell>

                                        <TableCell align="left" sx={tableData}>
                                            {task?.site?.name}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData} onClick={() => navigateTo(`/user/profile/${task?.userId?._id}`)}>
                                            {`${task?.userId?.firstname} ${task?.userId?.lastname}`}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData} onClick={() => navigateTo(`/user/profile/${task?.userId?._id}`)}>
                                            {task?.userId?.email}
                                        </TableCell>
                                        <TableCell align="left" sx={tableData}>
                                            Latitude: {task?.location?.lat} <br />
                                            Longitude: {task?.location?.lng} <br />
                                            <button onClick={() => handleMapNavigate(task?.location?.lat, task?.location?.lng)}>
                                                Navigate to Location
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {filteredPanic.length === 0 &&
                                    <EmptyTable colSpan={6} />
                                }
                            </TableBody>
                            <TablePagination
                                rowsPerPageOptions={perPages}
                                colSpan={7}
                                count={filteredPanic.length}
                                rowsPerPage={perPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Box>
    );
}
